import { CommonCMS, Wishlist } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";

export const wishlistModalMicrocopyKeys = [
    Wishlist.button.undoWishlist,
    Wishlist.button.viewWishList,
    Wishlist.addedToWishlistTitle,
    Wishlist.removedFromWishlistTitle,
] as const;

/**
 * The add/remove-wishlist modal is triggered both from page content (PLP/PDP, where these
 * keys live in the page microcopy set) and from the navigation search flyout, which renders
 * outside every page's PageMicrocopyProvider and therefore has no page set. Resolve from the
 * page set first and fall back to the shared set so the modal has its texts in both contexts.
 */
export const useWishlistModalMicrocopies = (): Record<string, string> => {
    const { getMultiple } = useMicrocopy();

    return {
        ...(getMultiple(CommonCMS.shared, wishlistModalMicrocopyKeys) ?? {}),
        ...(getMultiple(CommonCMS.page, wishlistModalMicrocopyKeys) ?? {}),
    };
};
